export default __webpack_public_path__ + "static/media/2363.bb1946ce.png";